"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=412%3A415))
 * @trackcomponent
 * @lastsynced 2025-04-11T14:43:36.228Z
 * @optimized using svgo:^3.0.2
 */
export const Notification = createSVGIcon(
  <rect
    x="16"
    y="1"
    width="8"
    height="8"
    rx="4"
    fill="#7D3E1E"
    stroke="#fff"
    strokeWidth="2"
  />,
  "Notification",
  { viewBox: "0 0 25 25", titleAccess: "Notification", fill: "none" }
);
